export const handleEnter = f => e => (e.key === "Enter" ? f(e) : null);
